import { useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import { Sentry, storeValue } from "../../utils"
import { useNavigationContext } from "../../hooks"
import { Platform } from "react-native"
import { useFetchTransactions } from "../queries"
import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { SignUpStackParamList } from "../../screens/onboarding-flow-v2/types.ts"
import { RootStackParamList } from "../../router/types.ts"

type AccountSkipResponse = {
  refreshToken: string
}
type MutationFnParams = {
  verificationId: string
}

export function useAccountSkip() {
  const { setIsLoggedIn } = useNavigationContext()
  const navigation = useNavigation<StackNavigationProp<SignUpStackParamList & RootStackParamList>>()
  const fetchTransactions = useFetchTransactions()

  return useMutation<AccountSkipResponse, unknown, MutationFnParams>({
    mutationFn: async ({ verificationId }) => {
      const response = await fetcher("/Account/Skip", {
        method: "PUT",
        body: JSON.stringify({
          verificationId,
        }),
      })
      const responseJson = await response.json()

      return responseJson
    },
    onSuccess: async (response) => {
      if (Platform.OS === "web") {
        const transactions = await fetchTransactions()
        if (!transactions?.paymentRequests.length) {
          Sentry.captureMessage("paymentRequests are empty")
          navigation.reset({
            index: 0,
            routes: [{ name: "DownloadTheAppScreen" }],
          })
          return
        }

        const paymentRequestId = transactions.paymentRequests[0].externalPaymentRequestId

        navigation.reset({
          index: 0,
          routes: [
            {
              name: "PaymentMethod",
              params: {
                paymentRequestId,
                isFirstPostOnboardingPayment: true,
              },
            },
          ],
        })

        return
      }
      if (response.refreshToken) {
        await storeValue("refreshToken", response.refreshToken)
      }
      await storeValue("isLoginDataStored", true.toString())
      setIsLoggedIn(true)
    },
    onError: (error) => {
      console.log("error?", error)
    },
  })
}
